import React from 'react';

import { StyledSocials } from './Socials.styles';

import { SocialsProps } from './Socials.types';

const Socials = ({
  socialList,
  renderSocial,
  renderLink,
  componentClassname = 'socials',
  customClassnames = '',
  customStyle = '',
}: SocialsProps) => {
  const renderSocialLink = (socialUrl: string, socialName: string) => {
    if (!socialUrl) {
      return renderSocial(socialName);
    }

    if (renderLink) {
      return renderLink({
        href: socialUrl,
        children: renderSocial(socialName),
        target: '_blank',
        additionalParams: {
          className: `${componentClassname}__social-wrapper ${componentClassname}__social-wrapper--${socialName}`,
        },
      });
    }

    return (
      <a
        className={`${componentClassname}__social-wrapper ${componentClassname}__social-wrapper--${socialName}`}
        href={socialUrl}
        target={'_blank'}
      >
        {renderSocial(socialName)}
      </a>
    );
  };

  return (
    <StyledSocials
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {socialList.map((social) => renderSocialLink(social.url, social.name))}
    </StyledSocials>
  );
};
Socials.displayName = 'Socials';

export default Socials;
